import React, { useEffect, useState } from "react"
import TableButton from "@components/TableButtons"

const PricesButtonGroup = ({
  elements,
  currentIndex,
  theme = "white-bg",
  flexHeight = false,
  groupId,
  localStoragePrefix,
}) => {
  const getInitialIndex = () => {
    const savedIndex = localStorage.getItem(`${localStoragePrefix}_${groupId}`)
    return savedIndex !== null
      ? parseInt(savedIndex, 10)
      : currentIndex === undefined
      ? 0
      : currentIndex - 1
  }

  const [selectedIndex, setSelectedIndex] = useState(getInitialIndex)

  useEffect(() => {
    if (typeof currentIndex !== "undefined") {
      setSelectedIndex(currentIndex - 1)
    }
  }, [currentIndex])

  const selectElement = (e, i) => {
    setSelectedIndex(i)
    localStorage.setItem(`${localStoragePrefix}_${groupId}`, i)
    if (e.callback) {
      e.callback(e.id)
    }
  }

  const isSelected = (i, isSeparator) => {
    return selectedIndex === i && !isSeparator
  }

  const getClasses = (i, isSeparator) => {
    const selected = isSelected(i, isSeparator)
    let classes = selected
      ? "bg-[#151124] !text-[#FFFFFF] border-[#151124] border-[1px] desk:!p-[10px]"
      : "bg-white border-[#D0CFD3] border-[1px] desk:!p-[10px]"

    if (selected) {
      if (i === elements.length - 1) {
        classes += " border-l-0"
      } else if (i !== 0) {
        classes += " border-r-0 border-l-0"
      } else {
        classes += " border-r-0"
      }
    }
    return classes
  }

  return (
    <div
      className={`flex flex-wrap ${flexHeight ? "" : "h-[48px]"} min-w-[36px]`}
    >
      {elements.map((e, i) => (
        <div key={`button-group-${i}-${groupId}`} className="mr-2">
          <TableButton
            className={`rounded-md h-[36px] min-w-[36px] p-[10px] desk:!text-[14px] desk:h-[40px] desk:min-w-[40px] !mt-0 !mb-1 ${getClasses(
              i,
              e.separator
            )}`}
            disabled={e.separator === true}
            theme={theme}
            selected={isSelected(i, e.separator)}
            onClick={() => selectElement(e, i)}
          >
            {e.text}
          </TableButton>
        </div>
      ))}
    </div>
  )
}

export default PricesButtonGroup
